import { render, staticRenderFns } from "./IndependentStatusBanner.vue?vue&type=template&id=5449ce50&scoped=true&"
import script from "./IndependentStatusBanner.vue?vue&type=script&lang=js&"
export * from "./IndependentStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./IndependentStatusBanner.vue?vue&type=style&index=0&id=5449ce50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449ce50",
  null
  
)

export default component.exports